import React, { useEffect } from 'react';
import ReactGA from 'react-ga';

const withPageTracking = (WrappedComponent, options = {}) => {
    const trackPage = page => {
        ReactGA.set({
            page,
            ...options
        });
        ReactGA.pageview(page);
    };

    const ComponentWithPageTracking = props => {
        const {
            location: { pathname }
        } = props;
        useEffect(() => trackPage(pathname), [pathname]);

        return <WrappedComponent {...props} />;
    };

    return ComponentWithPageTracking;
};

export default withPageTracking;
